import { ref } from 'vue'

import { defineNuxtPlugin } from '#imports'

const CLIENT_IP_URL = 'https://api.ipify.org?format=json'
const TIMEOUT_MS = 3000

async function fetchClientIp() {
  let timer = null
  const timeout = new Promise((resolve) => {
    timer = setTimeout(() => resolve({ ip: '' }), TIMEOUT_MS)
  })
  const request = fetch(CLIENT_IP_URL)
    .then((response) => response.json())
    .catch(() => ({ ip: '' }))

  const data = await Promise.race([request, timeout])
  clearTimeout(timer)
  return data?.ip || ''
}

// 僅在 client 端執行（檔名 .client.js 自動只在瀏覽器註冊），用於 ERR_998 Sentry 上報補充來源 IP
// fire-and-forget：不阻塞 plugin 初始化，IP 抓到後更新 ref
export default defineNuxtPlugin(() => {
  const clientIp = ref('')

  fetchClientIp()
    .then((ip) => {
      clientIp.value = ip
    })
    .catch((error) => {
      console.warn('[Client IP] Fetch client IP failed.', error)
    })

  return {
    provide: {
      clientIp,
    },
  }
})
